import styled from 'styled-components';
import { StyledProps } from 'types/styled';

import '../../../vendor/roundedBarCharts';

import {
  Avatar as MuiAvatar,
  Breadcrumbs as MuiBreadcrumbs,
  Button as MuiButton,
  Chip as MuiChip,
  Card as MuiCard,
  Divider as MuiDivider,
  Grid as MuiGrid,
  LinearProgress as MuiLinearProgress,
  Typography as MuiTypography,
  InputBase as MuiInputBase,
} from '@mui/material';

import { darken } from 'polished';

import { SpacingProps } from '@mui/system';

// Use sx prop or styled-components for spacing instead of system spacing utility
export const Breadcrumbs = styled(MuiBreadcrumbs)<SpacingProps>``;

export const Button = styled(MuiButton)<any>`
  text-transform: none;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 8px;
  transition: all 0.15s ease;

  &.MuiButton-outlined {
    border-color: ${(props: StyledProps) => (props.theme.palette.mode === 'dark' ? '#333' : '#e5e5e5')};

    &:hover {
      border-color: ${(props: StyledProps) => (props.theme.palette.mode === 'dark' ? '#444' : '#d4d4d4')};
      background: ${(props: StyledProps) =>
        props.theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'};
    }
  }
`;

export const Card = styled(MuiCard)<StyledProps & SpacingProps>`
  /* Use theme surface colors so cards match app dark mode */
  background: ${(props) => props.theme.palette.background.paper};
  border: 1px solid ${(props) => props.theme.palette.divider};
  border-radius: 12px;
  box-shadow: none;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => props.theme.palette.divider};
  }
`;

export const Chip = styled(MuiChip)<StyledProps & SpacingProps>`
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.8125rem;
  height: 24px;

  &.MuiChip-colorPrimary {
    background-color: ${(props) => props.theme.palette.primary.main};
    color: ${(props) => props.theme.palette.primary.contrastText};
  }
`;

export const Divider = styled(MuiDivider)<SpacingProps>``;

export const Grid = styled(MuiGrid)<SpacingProps>``;

export const LinearProgress = styled(MuiLinearProgress)<SpacingProps>``;

export const Spacer = styled.div<SpacingProps>``;

export interface TypographyPropsType extends SpacingProps {
  component?: string;
}

export type ProfileParams = {
  teamId?: string;
};

export const Typography = styled(MuiTypography)<TypographyPropsType>``;

export const Centered = styled.div`
  text-align: center;
`;

export const Avatar = styled(MuiAvatar)`
  display: inline-block;
  height: 128px;
  width: 128px;
`;

export const AboutIcon = styled.span`
  display: flex;
  padding-right: ${(props) => props.theme.spacing(2)}px;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const ChartWrapper = styled.div`
  height: 280px;
  position: relative;
`;

export const StatsIcon = styled.div`
  position: absolute;
  right: 16px;
  top: 32px;

  svg {
    width: 32px;
    height: 32px;
    color: ${(props) => props.theme.palette.secondary.main};
  }
`;

export const ProductsChip = styled(Chip)<{ rgbcolor?: string }>`
  height: 20px;
  padding: 4px 0;
  font-size: 90%;
  background-color: ${(props) => props.rgbcolor};
  color: ${(props) => props.theme.palette.common.white};
`;

export const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(12)}px);
`;

export const Input = styled(MuiInputBase)`
  color: inherit;
  width: 100%;

  > input {
    color: ${(props) => props.theme.header.search.color};
    padding-top: ${(props) => props.theme.spacing(2.5)}px;
    padding-right: ${(props) => props.theme.spacing(2.5)}px;
    padding-bottom: ${(props) => props.theme.spacing(2.5)}px;
    padding-left: ${(props) => props.theme.spacing(12)}px;
    width: 230px;
  }
`;

export const Search = styled.div`
  border-radius: 2px;
  background-color: ${(props) => props.theme.header.background};
  position: relative;
  width: 300px;

  &:hover {
    background-color: ${(props) => darken(0.05, props.theme.header.background)};
  }
  display: block;ƒ
`;

export const SearchIconWrapper = styled.div`
  width: 50px;
  height: 100%;
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const IconContainer = styled.span`
  position: relative;
  top: 3px;
  left: 5px;
  visibility: hidden;

  &:hover {
    path {
      fill: blue;
    }
  }
`;
